import type { graphql, ResultOf } from '@/gql/graphql';
import type InsertMessageReactionOneOptimisticFragment from './InsertMessageReactionOneOptimisticFragment';

export default function getInsertedReactionCount(
  messageReaction: ReturnType<
    typeof graphql.scalar<'message_reaction_insert_input'>
  >,
  messageFragment: ResultOf<typeof InsertMessageReactionOneOptimisticFragment>,
) {
  const content = messageReaction.content;

  if (!content) {
    return messageFragment.reaction_count || [];
  }

  const reactionCount = messageFragment.reaction_count || [];
  const index = reactionCount.findIndex((item: { [key: string]: number }) =>
    Object.hasOwn(item, content),
  );

  if (index === -1) {
    return [...reactionCount, { [content]: 1 }];
  }

  return reactionCount.map((item, itemIndex) => {
    if (itemIndex !== index) {
      return item;
    }

    const currentCount = Number(item[content] || 0);

    return {
      ...item,
      [content]: currentCount + 1,
    };
  });
}
